import { render, staticRenderFns } from "./SmsReplacementTerm.vue?vue&type=template&id=3816439a&"
import script from "./SmsReplacementTerm.vue?vue&type=script&lang=js&"
export * from "./SmsReplacementTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports